import styled from '@emotion/styled'
import React, { useState } from 'react'

import TestRulePopover from './TestRoutingRulePopover'
import Button from 'components/Button'
import { Rule } from 'types/rules'
import { Template } from 'types/template'

const StyledButton = styled(Button)`
	bottom: 4px;
	right: 15px;
`

type Props = {
	templates: Template[]
	localRules: Rule[]
	onHighlightRule: (id: string | null) => void
}

const TestRoutingRuleSection: React.FC<Props> = ({ templates, localRules, onHighlightRule }) => {
	const [showPopover, setShowPopover] = useState(false)

	return (
		<>
			<StyledButton
				kind="secondary"
				onClick={() => setShowPopover((currentShowPopover) => !currentShowPopover)}
				disableHover
				mediumDesktop
			>
				Test rule
			</StyledButton>
			{showPopover && (
				<TestRulePopover
					templates={templates}
					localRules={localRules}
					onClose={() => setShowPopover(false)}
					onHighlightRule={onHighlightRule}
				/>
			)}
		</>
	)
}

export default TestRoutingRuleSection
